export const MONTHS_IN_YEAR = 12;

export enum CurrencyCode {
	BTC = "BTC",
	CZK = "CZK",
	EUR = "EUR",
	USD = "USD",
	GBP = "GBP",
	PLN = "PLN",
	CHF = "CHF",
}

export const INCREMENTAL_COUNTER_MAX = 9_999_999;
export const INCREMENTAL_COUNTER_STEP = 1_000;
export const INCREMENTAL_COUNTER_HOLD = {
	startDelayMs: 500,
	intervalMs: 500,
	minIntervalMs: 50,
	accelerationMs: 50,
};

export const INCREMENTAL_COUNTER_V2_STEP = 5_000;
export const AMOUNT_STEPPER_HOLD = {
	startDelayMs: 400,
	intervalMs: 120,
};
export const AMOUNT_STEPPER_FIELD_STEP = 1_000;
export const CONTACT_DIALOG_AUTO_CLOSE_MS = 4_000;
